export enum RoomState {
  loading = 'loading',
  standBy = 'standBy',
  playing = 'playing',
}

export enum GameState {
  loading = 'loading',
  ready = 'ready',
  firstNight = 'firstNight',
  day = 'day',
  voteStart = 'voteStart',
  voteEnd = 'voteEnd',
  finalVoteReady = 'finalVoteReady',
  finalVoteStart = 'finalVoteStart',
  night = 'night',
  takeOther = 'takeOther',
  gameover = 'gameover',
}

export enum CauseOfDeath {
  punished = 'punished',
  mafia = 'mafia',
  killer = 'killer',
  bomber = 'bomber',
  sniper = 'sniper',
  assassin = 'assassin',
  boy = 'boy',
  daughter = 'daughter',
  eaten = 'eaten',
}

export enum RoleId {
  people = 1,
  nobleman,
  believers,
  police,
  investigator,
  doctor,
  dancer,
  sniper,
  survivor,
  cinderellaGirl,
  mafia,
  godfather,
  godfatherAndMafia,
  daughter,
  prostitute,
  traitor,
  trickster,
  bomber,
  killer,
  boy,
  assassin,
  pickpocket,
  crab,
}

export enum Side {
  people = '市民',
  mafia = 'マフィア',
  mafiaLeader = 'マフィア幹部',
  neutrality = '中立',
  outlaw = 'アウトロー',
}

export enum Action {
  targetSelect = 1,
  nothing,
  armor,
  detonate,
}